// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__Oiibo","modalBody":"MealsPop_modalBody__sYzAT"};